import { Component, Input } from '@angular/core';
import { FiltersComponent } from '../../../common/filters.component';

@Component({
	selector: 'app-tourist-guides-calendar-filters',
	templateUrl: './tourist-guides-calendar-filters.component.html',
	styleUrls: ['./tourist-guides-calendar-filters.component.css'],
})
export class TouristGuidesFiltersComponent extends FiltersComponent {
	@Input() touristGuides: Array<any>;
	@Input() touristGuideTypes: Array<any>;
	filters = {
		touristGuide: [],
		touristGuideType: [],
		rates: [],
		showDeleted: null,
	};
	yesno = [
		{ id: 0, name: 'Nie' },
		{ id: 1, name: 'Tak' },
	];

	filtersDefault() {
		this.filters.showDeleted = 0;
		this.filters.touristGuideType = ['1', '2', '4', '5', '6'];
	}
}
